// Category color mapping shared across the app
export const CATEGORY_BADGE = {
  Concert: "bg-[#FFE0CC] text-[#C7421F]",     // orange (anciennement jaune)
  Festival: "bg-[#FECACA] text-[#991B1B]",    // rouge
  Sport: "bg-[#DBEAFE] text-[#1E3A8A]",       // bleu
  Marché: "bg-[#BBF7D0] text-[#14532D]",      // vert
  Repas: "bg-[#EDE9FE] text-[#5B21B6]",       // violet
  Soirée: "bg-white text-ink border border-[#F0E0CC]", // blanc
};

export const CATEGORY_CHIP_INACTIVE = {
  Concert: "bg-[#FFE0CC] text-[#C7421F] border-[#FFD9A8] hover:border-[#E55934]",
  Festival: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA] hover:border-[#DC2626]",
  Sport: "bg-[#DBEAFE] text-[#1E40AF] border-[#BFDBFE] hover:border-[#2563EB]",
  Marché: "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0] hover:border-[#16A34A]",
  Repas: "bg-[#F5F3FF] text-[#5B21B6] border-[#DDD6FE] hover:border-[#7C3AED]",
  Soirée: "bg-white text-ink border-[#F0E0CC] hover:border-ink",
};

export const CATEGORY_CHIP_ACTIVE = {
  Concert: "bg-[#E55934] text-white border-[#E55934] shadow-sm",
  Festival: "bg-[#DC2626] text-white border-[#DC2626] shadow-sm",
  Sport: "bg-[#2563EB] text-white border-[#2563EB] shadow-sm",
  Marché: "bg-[#16A34A] text-white border-[#16A34A] shadow-sm",
  Repas: "bg-[#7C3AED] text-white border-[#7C3AED] shadow-sm",
  Soirée: "bg-white text-ink border-ink shadow-sm ring-2 ring-ink/10",
};
